import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useWamImageUpload } from '../../../hooks/use-wam-image-upload';
import { Drawer } from '../drawer/drawer';
import { DrawerPositions } from '../drawer/drawer-types';
import { InstructionStep } from './fragments/instruction-step';
import { WamInstructionsDrawerProps } from './wam-instructions-drawer-types';
import styles from './wam-instructions-drawer.module.scss';
import { FooterContent } from './fragments/footer-content';

export const WamInstructionsDrawer = ({
  onClose,
  isOpen,
  onImageSelect,
  onCrop,
}: WamInstructionsDrawerProps): React.ReactElement => {
  const { t } = useTranslation();
  const { steps, inputRef, buttonRef, handleImageUpload } = useWamImageUpload({ onClose, onImageSelect, onCrop });

  useEffect(() => {
    buttonRef.current?.focus();
  }, [isOpen, buttonRef]);

  return (
    <Drawer
      id="wam-instructions-drawer"
      drawerPosition={DrawerPositions.Left}
      onClose={onClose}
      isOpen={isOpen}
      closeIconSize={24}
      addClass={styles['wam-instructions-drawer']}
      footerContent={
        <FooterContent
          inputRef={inputRef}
          buttonRef={buttonRef}
          handleImageUpload={handleImageUpload}
          footerContentText={t('writeMessage.footerContent')}
        />
      }
      trapFocus
    >
      {steps.map(({ imageUrl, title, text }, index) => (
        <InstructionStep
          key={`wam-instruction-${index + 1}`}
          imageUrl={imageUrl}
          text={text}
          title={title}
          stepNumber={index + 1}
        />
      ))}
    </Drawer>
  );
};
